export const VisitorDriveType = {
    List: [
        {value: "00", label: "VMS_REQUEST_VISITOR_DRIVE_TYPE_NONE"},
        {value: "01", label: "VMS_REQUEST_VISITOR_DRIVE_TYPE_DRIVER"},
        {value: "02", label: "VMS_REQUEST_VISITOR_DRIVE_TYPE_PASSENGER"},
    ],
    Map: new Map<string, string>([
        ['00', 'VMS_REQUEST_VISITOR_DRIVE_TYPE_NONE'],
        ['01', 'VMS_REQUEST_VISITOR_DRIVE_TYPE_DRIVER'],
        ['02', 'VMS_REQUEST_VISITOR_DRIVE_TYPE_PASSENGER'],
    ]),
    Enum: {
        None: '00',
        Driver: "01",
        Passenger: '02'
    }
};